import { inject } from '@angular/core'

import { ToastMessageService } from '@flowx/designer/shared/services/toast-message.service'

/** Runs an action's request and reports a failure in a toast: the backend's title, else `fallbackMessage`. */
export type WithErrorToast = (fallbackMessage: string, run: () => Promise<unknown>) => Promise<void>

/**
 * Shared by the handler factories, so a failed action reads the same from each of them. Must be called
 * in an injection context, like them.
 */
export const injectWithErrorToast = (): WithErrorToast => {
  const toastMessageService = inject(ToastMessageService)

  return async (fallbackMessage, run) => {
    try {
      await run()
    } catch (error) {
      toastMessageService.showErrorMessage(error.error?.title || fallbackMessage)
    }
  }
}
